/**
 * @deprecated Is replaced by the useSignInFormMergeCart plugin.
 */
export function useMergeCustomerCart() {
  return null
}
